import React, { useRef } from "react";

const Live = () => {
  const liveVideoId = "5wdsouctcHQ";
  const iframeRef = useRef(null);

  const enableSound = () => {
    iframeRef.current.contentWindow.postMessage(
      '{"event":"command","func":"unMute","args":""}',
      "*"
    );
  };

  return (
    <div
      className="relative w-full h-screen cursor-pointer"
      onClick={enableSound}
    >
      <iframe
        style={{width:'100%',height:'100vh'}}
        ref={iframeRef}
        className="w-full h-full"
        src={`https://www.youtube.com/embed/${liveVideoId}?autoplay=1&mute=1&enablejsapi=1&playsinline=1`}
        allow="autoplay; encrypted-media"
        allowFullScreen
        title="Live"
      ></iframe>

      <div className="absolute inset-0 flex items-center justify-center text-white bg-black/30 text-xl">
        🔊 Tap anywhere to enable sound
      </div>
    </div>
  );
};

export default Live;
